import { useEffect, useRef, useState } from "react";
import { getGalleryPhotos, addGalleryPhoto, deleteGalleryPhoto } from "../../../api/api";
import { API_URL } from "../../../constants/constants";
import { useTranslation } from "react-i18next";

export const GalleryPhotosManager = ({ homeSlidingPhotoId }: { homeSlidingPhotoId: number }) => {
    const [photos, setPhotos] = useState<any[]>([]);
    const [image, setImage] = useState<File | null>(null);
    const [preview, setPreview] = useState<string | null>(null);
    const fileRef = useRef<HTMLInputElement>(null);
    const { t } = useTranslation();

    const load = () =>
        getGalleryPhotos(homeSlidingPhotoId)
            .then(setPhotos)
            .catch(console.error);

    useEffect(() => { load(); }, [homeSlidingPhotoId]);

    const handleImage = (e: React.ChangeEvent<HTMLInputElement>) => {
        const f = e.target.files?.[0] || null;
        setImage(f);
        if (f) setPreview(URL.createObjectURL(f));
    };

    const handleAdd = async () => {
        if (!image) return;
        await addGalleryPhoto(homeSlidingPhotoId, image);
        setImage(null);
        setPreview(null);
        load();
    };

    const handleDelete = async (id: number) => {
        if (!window.confirm("Supprimer cette photo ?")) return;
        await deleteGalleryPhoto(id);
        load();
    };

    return (
        <div className="admin-card">
            <p className="admin-section-title">Photos de galerie liées</p>

            {/* Upload */}
            <div className="admin-form">
                <div className="admin-upload-zone" onClick={() => fileRef.current?.click()}>
                    <input ref={fileRef} type="file" accept="image/*" onChange={handleImage} />
                    {preview
                        ? <div className="admin-preview"><img src={preview} alt="preview" /></div>
                        : <p>{t("admin.products.click-to-select-image")}</p>
                    }
                </div>
                <button
                    className="btn-admin btn-admin-primary"
                    onClick={handleAdd}
                    disabled={!image}
                >
                    Ajouter
                </button>
            </div>

            {/* Liste */}
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem', marginTop: '1rem' }}>
                {photos.map(p => (
                    <div key={p.id} style={{ position: 'relative' }}>
                        <img
                            src={`${API_URL}${p.imageUrl}`}
                            alt=""
                            style={{ width: 120, height: 80, objectFit: 'cover', borderRadius: 4 }}
                        />
                        <button
                            className="btn-admin btn-admin-danger"
                            onClick={() => handleDelete(p.id)}
                            style={{ position: 'absolute', top: 2, right: 2, padding: '2px 6px', fontSize: '0.7rem' }}
                        >
                            ✕
                        </button>
                    </div>
                ))}
                {photos.length === 0 && <p style={{ color: '#888' }}>Aucune photo liée</p>}
            </div>
        </div>
    );
};
